import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './components/Login/Login'
import Tours from './views/Tours'
import Events from './views/Events'
import Clients from './views/Clients'
import Menus from './views/Menus'
import Establishment from './views/Establishment'
import cookieToken from './utils/cookieToken'
Vue.use(Router)

export var Auth = {
	loggedIn: false,
	login: function(token) {
		cookieToken.setCookie(token)
		this.loggedIn = true
	},
	logout: function() {
		cookieToken.resetCookie()
		this.loggedIn = false
	},
	tokenLogin: function() {
		this.loggedIn = true
	}
}

var router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/eventos',
			name: 'eventos',
			component: Events,
			meta: { requiresAuth: true }
		},
		{
			path: '/percursos',
			name: 'percursos',
			component: Tours,
			meta: { requiresAuth: true }
		},
		{
			path: '/clientes',
			name: 'clientes',
			component: Clients,
			meta: { requiresAuth: true }
    },
    {
      path: '/menus',
      name: 'menus',
      component: Menus,
      meta: { requiresAuth: true }
		},
    {
      path: '/establecimento',
      name: 'establecimento',
      component: Establishment,
      meta: { requiresAuth: true }
		}
	]
})

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth) && !Auth.loggedIn) {
		next({ path: '/login', query: { redirect: to.fullPath } })
	} else {
		next()
	}
})

export default router
